import React from 'react';
import { Helmet } from 'react-helmet-async';
import { Grid } from 'src/components';
import BaseComponent from 'src/core/base.component';
import { translate } from 'src/i18n/tHelper';
import KurumBonusTanimlariListe from './Liste';
import { useAppSelector } from 'src/store';
import KurumBonusTanimlariEkle from './Ekle';

const translatePath = "pages|kurumBonusTanimlari";
const KurumBonusTanimlari = (): JSX.Element => {
    const state = useAppSelector(s => s.kurumBonusTanimlari);
    return (
        <>
            <Helmet><title>{translate(translatePath, "Kurum Bonus Tanımları")}</title></Helmet>
            <BaseComponent>
                <Grid container>
                    <Grid item>
                        <KurumBonusTanimlariListe />
                    </Grid>
                </Grid>
            </BaseComponent>
            {state.open && <KurumBonusTanimlariEkle />}
        </>
    );
};

export default KurumBonusTanimlari;